<template>
  <div class="wf-checkbox" :class="{ unselected: isUnselected, [$style.disabled]: disabled }">
    <WfIcon :icon="isMixed ? 'hyphen' : 'checkmark'" />
  </div>
</template>

<style lang="scss" module>
.disabled {
  opacity: 0.5;
}
</style>

<script>
import WfIcon from '@/components/WfIcon.vue';

export default {
  components: {
    WfIcon,
  },
  props: {
    status: {
      type: String,
      default: 'selected',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    isUnselected() {
      return this.status === 'unselected';
    },
    isMixed() {
      return this.status === 'mixed';
    },
  },
};
</script>
